<script setup lang="ts">
import logoCotap from '~/assets/images/cotap/COTAP Logo CMYK.png'
import logoCotapDiap from '~/assets/images/cotap/COTAP Logo CMYK diap.png'

const localePath = useLocalePath()
const colorMode = useColorMode()

const logoSrc = computed(() =>
  colorMode.value === 'dark' ? logoCotapDiap : logoCotap
)
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <main class="grow flex flex-col gap-8 justify-center items-center">
      <NuxtLink :to="localePath('ct.index')">
        <img
          :src="logoSrc"
          alt="COTAP"
          class="h-10 w-auto object-contain"
        >
      </NuxtLink>
      <slot />
    </main>
  </div>
</template>
